import { keys } from "@/lib/i18n/portal";
import type { PaymentMethod } from "@/lib/api/types";

type TranslationFn = (key: string) => string;

export function getPaymentMethodLabel(
  paymentMethod: PaymentMethod,
  t: TranslationFn,
): string {
  if (paymentMethod === "EXTERNAL_ONLINE") {
    return t(keys.orders.paymentMethodExternalOnline);
  }
  return t(keys.orders.paymentMethodCod);
}
